import i18n, { languages } from "../i18n";
import { useTranslation } from "react-i18next";
interface LanguageModalProps {
  show: boolean;
  onClose: () => void;
}

const LanguageModal: React.FunctionComponent<LanguageModalProps> = ({ show, onClose }) => {
  const { t } = useTranslation();

  return (
    <div className={"modal " + (show ? "" : "hidden")} tabIndex={-1} aria-modal="true" role="dialog">
      <div className="modal__dialog">
        <div className="modal__body">
          <div className="text-secondary mb-4">{t("Select a language")}</div>
          <ul className="modal__list">
            {languages.map((language) => (
              <li key={language.key}>
                <div className="flex items-center justify-between">
                  <div
                    className="flex items-center gap-2"
                    onClick={() => {
                      i18n.changeLanguage(language.key);
                      localStorage.setItem("language", language.key);
                      onClose();
                      let htmlElement = document.getElementById("html");
                      if (htmlElement) {
                        htmlElement.dir = language.rtl ? "rtl" : "ltr";
                        htmlElement.lang = language.key;
                      }
                    }}
                  >
                    <div
                      className="language-selector__list-image"
                      style={{ backgroundImage: `url("${language.flag}")` }}
                    ></div>
                    {language.name}
                  </div>

                  <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="rtl-hide">
                    <path
                      d="M1 11L4.50024 6.6247C4.79242 6.25948 4.79242 5.74052 4.50024 5.3753L0.999999 1"
                      stroke="#3F4067"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                  <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="rtl-show">
                    <g transform="matrix(-1,0,0,1,5.71937,0)">
                      <path
                        d="M1,11L4.5,6.625C4.792,6.259 4.792,5.741 4.5,5.375L1,1"
                        stroke="#3F4067"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                  </svg>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default LanguageModal;